import ReducerTypes from "../Types/ReducerTypes"

const INITIAL_STATE = {
    message: "",
    appLoading: false,
}


function appReducer(state = INITIAL_STATE, action){

    switch (action.type) {
        case ReducerTypes.HEADER_MESSAGE:
            return {...state, message: action.payload}
        case ReducerTypes.TOGGLE_LOADING: {
            return {
                ...state,
                appLoading: !state.appLoading,
            }
        }
        default:
            return state;
    }
}


export default appReducer;